import clsx from "clsx"

import { getSymbolByName } from "@utils/getSymbolByName"

import styles from "./HotKey.module.scss"
import { HotKeyProps } from "./HotKey.types"

export default function HotKey(props: HotKeyProps) {
    const { symbolName, className } = props

    const symbol = getSymbolByName(symbolName)

    return <span className={clsx(styles.base, className)}>{symbol}</span>
}
